import * as React from 'react';
import { PillButtonContent } from './PillButton'
import PopOverMenu from '../PopOver/PopOverMenu'
import PillButton from './PillButton'
import './PillMenu.css';

export type ExternalProps = {
  buttons: PillButtonContent[],
  selected: string,
  disableAll: boolean,
  onClick: (type: string) => void
}

export type ValueProps = ExternalProps

export type EventProps = {}

export type Props = ValueProps & EventProps

export type State = {
  hideIcons: boolean,
  shownButtons: PillButtonContent[],
  hiddenButtons: PillButtonContent[]
}

export const pillMenuNormalScreenWidth = 960
export const pillMenuNormalIconsScreenWidth = 1125
export const pillMenuPremiumScreenWidth = 1215
export const pillMenuPremiumIconsScreenWidth = 1430

export default class PillMenu extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.handleResize = this.handleResize.bind(this)
    this.handleButtons = this.handleButtons.bind(this)

    const resolvedButtons = this.handleButtons()

    this.state = {
      hideIcons: false,
      hiddenButtons: resolvedButtons.hiddenButtons,
      shownButtons: resolvedButtons.shownButtons,
    }
  }

  getSelectedButton(buttons: PillButtonContent[]) {
    const windowHashArray = window.location.hash.split('/')
    const selectedType = windowHashArray[windowHashArray.length - 1]

    return buttons.filter(button => button.label.toLowerCase().replace(' ', '-') === selectedType)
  }

  isSelectedButtonHidden(hiddenButtons: PillButtonContent[]) {
    return this.getSelectedButton(hiddenButtons).length > 0
  }

  renderButton(content: PillButtonContent) {
    const {selected, disableAll, onClick} = this.props;
    const {hideIcons} = this.state;

    return (
        <PillButton key={content.label} content={content} selected={selected} disableAll={disableAll} onClick={onClick} hideIcon={hideIcons}/>
    )
  }

  dropdownButtonOnClick(button: PillButtonContent) {
    const {onClick} = this.props

    const type = button.label.toLowerCase().replace(' ', '-')
    const hash = window.location.hash

    window.location.hash = `${hash.substring(0, hash.lastIndexOf('/'))}/${type}`
    onClick(type)
  }

  showButton(button: PillButtonContent) {
    const {hiddenButtons, shownButtons} = this.state

    const hiddenButton = shownButtons.pop()
    if (hiddenButton) hiddenButtons.push(hiddenButton)

    const shownButton = hiddenButtons.splice(hiddenButtons.indexOf(button), 1)
    shownButtons.push(shownButton[0])

    this.setState({shownButtons: shownButtons, hiddenButtons: hiddenButtons})
    this.dropdownButtonOnClick(button)
  }

  getPopoverOptions(buttons: PillButtonContent[]) {
    const {disableAll} = this.props

    const onClick = (button: PillButtonContent) => this.showButton.bind(this, button)

    return buttons.map(button => ({icon: button.iconName, label: button.label, onClick: onClick(button), disabled: disableAll}))
  }

  handleButtons() {
    const {buttons} = this.props
    const width = window.innerWidth

    let hiddenButtons: PillButtonContent[] = []
    let shownButtons: PillButtonContent[] = []

    const hideIcons = (buttons.length < 8 && width < pillMenuNormalIconsScreenWidth) ||
      (buttons.length > 7 && width < pillMenuPremiumIconsScreenWidth);

    if ((buttons.length < 8 && width < pillMenuNormalScreenWidth) || (buttons.length > 7 && width < pillMenuPremiumScreenWidth)) {
      hiddenButtons = [...buttons]
      shownButtons = hiddenButtons.splice(0, 5)
    } else {
      shownButtons = [...buttons]
    }

    if (this.isSelectedButtonHidden(hiddenButtons)) {
      const buttonIn = this.getSelectedButton(hiddenButtons)[0]
      const buttonOut = shownButtons.pop()

      if (buttonOut) hiddenButtons.push(buttonOut)
      shownButtons.push(buttonIn)

      hiddenButtons.splice(hiddenButtons.indexOf(buttonIn), 1)
    }

    return {
      hiddenButtons: hiddenButtons,
      shownButtons: shownButtons,
      hideIcons: hideIcons
    }
  }

  handleResize() {
    const resolvedButtons = this.handleButtons()

    this.setState({
      hiddenButtons: resolvedButtons.hiddenButtons,
      shownButtons: resolvedButtons.shownButtons,
      hideIcons: resolvedButtons.hideIcons
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any): void {
    if (prevProps.buttons.length !== this.props.buttons.length) {
      this.handleResize()
    }
  }

  render() {
    const {hiddenButtons, shownButtons} = this.state;

    const popoverOptions = this.getPopoverOptions(hiddenButtons)

    return (
      <div className={'pill-menu-container'}>
        {shownButtons.map(content => this.renderButton(content))}
        {hiddenButtons.length > 0 &&
          <div className={'pill-menu-dropdown-container pill-menu-button'}>
            <PopOverMenu
              pid={'pill-menu-popover'}
              clazz={'pill-menu-popover'}
              icon={'contextmenu'}
              iconSize={20}
              iconColor={'#6B6C6D'}
              options={popoverOptions}
            />
          </div>
        }
      </div>
    );
  }
}
